const smtpDottedLocalPart = /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-](?:[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-])?)(?=@)/;
const smtpQuotedLocalPart = /^("[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~\-(),:;<>@[\\\]" ]*")(?=@)/;
const smtpDomainPart = /^[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const unescapedQuote = /[^\\]"/;

// Custom addresses are addresses that specify a leading routing type, e.g.
// mapipdl:123987a987
//
// The routing type can be anything, as it can be configured at a tenant level.
// See #55765 for an example of a customer escalation caused by this.
//
// The route can also be anything, as its format depends on the routing type.
const addressWithCustomRoutingType = /^[A-Za-z0-9_-]+:.*$/;

const parseLocalPart = (emailAddress: string): string | null => {
    const dottedLocalPart = emailAddress.match(smtpDottedLocalPart);
    if (dottedLocalPart) {
        // consecutive dots not allowed in dotted local part
        if (dottedLocalPart[0].indexOf('..') !== -1) {
            return null;
        }
        return dottedLocalPart[0];
    }

    const quotedLocalPart = emailAddress.match(smtpQuotedLocalPart);
    if (quotedLocalPart) {
        // quotes must be escaped in quoted local part
        const match = unescapedQuote.exec(quotedLocalPart[0]);
        if (match && match.index !== quotedLocalPart[0].length - 2) {
            return null;
        }
        return quotedLocalPart[0];
    }

    return null;
};

export function isValidSmtpAddress(emailAddress: string): boolean {
    if (!emailAddress) {
        return false;
    }

    const localPart = parseLocalPart(emailAddress);
    if (!localPart) {
        return false;
    }
    const smtpDomainPartString = emailAddress.substring(localPart.length + 1);

    //VSO: 1041: Separate out form field validation to a different package.
    return !!smtpDomainPartString.match(smtpDomainPart);
}

export function isAddressWithCustomRoutingType(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return addressWithCustomRoutingType.test(emailAddress);
}

export default function isValidRecipientAddress(emailAddress: string): boolean {
    //VSO: 1041: Separate out form field validation to a different package.
    return isValidSmtpAddress(emailAddress) || isAddressWithCustomRoutingType(emailAddress);
}
